import { IAccountSalesInfo } from "@app/account/account.models";
import { createEntityAdapter, EntityAdapter } from "@ngrx/entity";

export const salesInfoAdapter: EntityAdapter<IAccountSalesInfo> = createEntityAdapter<IAccountSalesInfo>({
	selectId: info => info.accountId
});